module.exports = __webpack_public_path__ + "static/img/logo.00cfe8da.png";